import React from 'react';

const AboutVision = () => {
  return (
    <section className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto max-w-5xl text-center">
        <h2 className="mb-4 text-3xl font-bold uppercase text-accent md:text-4xl">
          Our Vision
        </h2>
        <p className="text-base leading-relaxed text-gray-700 md:text-lg">
          To honor women dealing with tough struggles holding onto their
          courage in every circumstance All Over India.
        </p>
      </div>
    </section>
  );
};

export default AboutVision;
